import React from 'react';
import css from './ProfilePage.module.css';
import { FormattedMessage } from 'react-intl';
import Icons from '../../components/Icons/Icons';
import { H4 } from '../../components';
import {
  programmeDurationOptions,
  yesNoOptions,
  geographicalReachOptions,
} from '../../util/general';
import { getLabelFromKey, isArrayLength } from '../../util/genericHelpers';

const renderSingleValueSection = (headingId, value, options) => {
  if (!value) return null;
  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        <div className={css.service}>
          <Icons name="check" /> {getLabelFromKey(value, options)}
        </div>
      </div>
    </>
  );
};

const renderArraySection = (headingId, keys, options) => {
  if (!isArrayLength(keys)) return null;
  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        {keys.map((key, index) => (
          <div key={index} className={css.service}>
            <Icons name="check" /> {getLabelFromKey(key, options)}
          </div>
        ))}
      </div>
    </>
  );
};

const KeyInformationSection = ({ publicData = {} }) => {
  const { programmeDuration, cdmRegulated, geographicalReach } = publicData;

  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.keyInformation" />
      </h2>

      {renderSingleValueSection(
        'ProfilePage.programmeDuration.heading',
        programmeDuration,
        programmeDurationOptions
      )}

      {renderSingleValueSection('ProfilePage.cdmRegulated.heading', cdmRegulated, yesNoOptions)}

      {renderArraySection(
        'ProfilePage.geographicalReach.heading',
        geographicalReach,
        geographicalReachOptions
      )}
    </div>
  );
};

export default KeyInformationSection;
